// Child route segments (no leading slash) for use in nested routes
export const CHILD_ROUTES = {
  LEARNING_PATHWAY: 'learning-pathway',
  WEBINAR: 'webinarList',
  WEBINAR_JOIN: 'newWebinarPage',
  SEARCH: 's',
  COURSES: 'courses',
  TOPIC: 'topic',
  LEARNING_MODULE: 'learning-module',
  WIDGET: 'widget',
  LEARNING_MODULE_CARD: 'learning-module-card',
  WIDGET_IFRAME_TEST: 'widget-iframe-test',
};

// Build full routes from base paths + child routes
export const ROUTES = {
  LEARN: {
    BASE: '/learn',
    LEARNING_PATHWAY: `/learn/${CHILD_ROUTES.LEARNING_PATHWAY}`,
    WEBINAR: `/learn/${CHILD_ROUTES.WEBINAR}`,
    WEBINAR_JOIN: `/learn/${CHILD_ROUTES.WEBINAR_JOIN}`,
    HOME: '/learn',
    SEARCH: `/learn/${CHILD_ROUTES.SEARCH}`,
    TOPIC: `/learn/${CHILD_ROUTES.TOPIC}`,
    LEARNING_MODULE: `/learn/${CHILD_ROUTES.LEARNING_MODULE}`,
  },
  NEW_LEARN: {
    BASE: '/su/learn',
    SEARCH: `/su/learn/${CHILD_ROUTES.SEARCH}`,
    LEARNING_MODULE: `/su/learn/${CHILD_ROUTES.LEARNING_MODULE}`,
  },
  TEST_LEARN: {
    BASE: '/su-test/learn',
    LEARNING_PATHWAY: `/su-test/learn/${CHILD_ROUTES.LEARNING_PATHWAY}`,
    WEBINAR: `/su-test/learn/${CHILD_ROUTES.WEBINAR}`,
    SEARCH: `/su-test/learn/${CHILD_ROUTES.SEARCH}`,
    TOPIC: `/su-test/learn/${CHILD_ROUTES.TOPIC}`,
    LEARNING_MODULE: `/su-test/learn/${CHILD_ROUTES.LEARNING_MODULE}`,
    WIDGET: `/su-test/learn/${CHILD_ROUTES.WIDGET}`,
    WIDGET_IFRAME_TEST: `/su-test/learn/${CHILD_ROUTES.WIDGET_IFRAME_TEST}`,
  },
  WIDGETS: {
    BASE: '/su-widgets',
    LEARNING_PATHWAY: `/su-widgets/${CHILD_ROUTES.LEARNING_PATHWAY}`,
    LEARNING_MODULE: `/su-widgets/${CHILD_ROUTES.LEARNING_MODULE}`,
    LEARNING_MODULE_CARD: `/su-widgets/${CHILD_ROUTES.LEARNING_MODULE_CARD}`,
  },
  LEGACY_ROUTES: {
    OLD_MODULES: '/learn/courses',
    OLD_WEBINARS: '/learn/webinarList?category=liveWebinar',
  },
  INTERACTIVE_LEARNING: '/interactive-learning',
};

export const MONS_ROUTES = {
  SIGN_IN: '/sign-in',
};

export const ROUTE_SEARCH_PARAM = {
  LEARNING_MODULE_ID: 'learningModuleId',
  LEGACY_MODULE_ID: 'moduleId',
  PAGE: 'pageNumber',
  REF: 'ref_',
  REF_LEGACY: 'ref',
  REF_TAG_LEGACY: 'refTag',
  REFERRAL: 'referral',
  CLIENT_ID: 'clientId',
};
